class ExtendSectionGuide extends ExtendSectionBase {
  constructor() {
    super();
  }

  init() {
    this._listenSectionLoad();
    const _safeInit = (fn) => {
      try {
        return fn();
      } catch (e) {
        console.warn(`[ExtendSectionS1V3] ${fn.name} 初始化失败:`, e);
        return null;
      }
    };
    _safeInit(() => this.initStartGuide());
    _safeInit(() => this.initLinksTutorials());
    _safeInit(() => this.initTutorials());
    _safeInit(() => this.initGuide());
  }

  initStartGuide() {
    const $startGuide = $("#extend-start-guide");
    if (!$startGuide.length) return;
    const $startGuideDialog = $("#extend-start-guide-dialog");
    const $startGuideDialogMain = $startGuideDialog.find(
      "#extend-start-guide-dialog-main"
    );
    const $startGuideDialogReturnBtn = $startGuideDialog.find(
      "#extend-start-guide-dialog-return"
    );
    $startGuide.on("click", () => {
      if (!$startGuideDialog.hasClass("dialog-show")) {
        $startGuideDialog.addClass("dialog-show");
        !!window.pauseAllVideo_hisong && window.pauseAllVideo_hisong();
      }
    });
    $startGuideDialog.find(".elg-dialog__close").on("click", () => {
      $startGuideDialog.removeClass("dialog-show");
    });
    $startGuideDialogReturnBtn.on("click", () => {
      $startGuideDialogMain.animate({ scrollTop: 0 }, 500);
    });
  }

  initLinksTutorials() {
    const $tutorialsItem = $('[name="extend-links-tutorials-item"]');
    if (!$tutorialsItem.length) return;
    $tutorialsItem.on("click", function () {
      const $item = $(this);
      const sectionId = $item.attr("section-id");
      const tutorialsIndex = $item.attr("tutorials-index");
      const $tutorialsDialog = $(
        `#extend-links__tutorials-dialog--${sectionId}`
      );
      const $tutorialsVideo = $(
        `#extend-links__tutorials-video--${sectionId}-${tutorialsIndex}`
      );
      if ($tutorialsDialog.hasClass("el-tutorials-dialog--show")) return;
      $tutorialsDialog.addClass("el-tutorials-dialog--show");
      $tutorialsVideo.addClass("el-tutorials-video--show");
      $tutorialsDialog.find(".el-tutorials-dialog__close").on("click", () => {
        $tutorialsDialog.removeClass("el-tutorials-dialog--show");
        $tutorialsVideo.removeClass("el-tutorials-video--show");
        $tutorialsVideo.find("video").each(function () {
          this.pause();
        });
      });
    });
  }

  initTutorials() {
    const $tutorialsItem = $('[name="extend-tutorials-item"]');
    if (!$tutorialsItem.length) return;

    const dialogShowClass = "et-dialog--show";
    const videoShowClass = "et-video--show";
    const eventNamespace = ".extendTutorials";

    const pauseVideos = ($videos) => {
      $videos.find("video-media").each(function () {
        this.pause();
      });
    };

    const closeDialog = ($dialog) => {
      const $visibleVideos = $dialog.find(`.${videoShowClass}`);
      $dialog.removeClass(dialogShowClass);
      $visibleVideos.removeClass(videoShowClass);
      pauseVideos($visibleVideos);
    };

    const getTutorialVideos = (sectionId, tutorialsIndex) => {
      const video = document.getElementById(
        `extend-tutorials-video--${sectionId}-${tutorialsIndex}`
      );
      const video2 = document.getElementById(
        `extend-tutorials-video2--${sectionId}-${tutorialsIndex}`
      );
      return $([video, video2].filter(Boolean));
    };

    $tutorialsItem
      .off(`click${eventNamespace}`)
      .on(`click${eventNamespace}`, function () {
        const $item = $(this);
        const sectionId = $item.attr("section-id");
        const tutorialsIndex = $item.attr("tutorials-index");
        if (!sectionId || !tutorialsIndex) return;

        const $dialog = $(`#extend-tutorials-dialog--${sectionId}`);
        if (!$dialog.length || $dialog.hasClass(dialogShowClass)) return;

        const $tutorialsVideos = getTutorialVideos(sectionId, tutorialsIndex);
        console.log("$tutorialsVideos", $tutorialsVideos);
        $dialog
          .off(`click${eventNamespace}`, ".et-dialog__close")
          .on(`click${eventNamespace}`, ".et-dialog__close", function () {
            closeDialog($dialog);
          });

        $dialog.addClass(dialogShowClass);
        $tutorialsVideos.addClass(videoShowClass);
      });
  }

  initGuide() {
    const $guide = $('[name="extend-guide"]');
    if (!$guide.length) return;
    $guide.each((index, element) => {
      const extendGuideDialogId = $(element).attr("extend-guide-dialog-id");
      const $guideDialog = $(`#guide-dialog-${extendGuideDialogId}`);
      $(element).on("click", () => {
        if (!$guideDialog.hasClass("eg-dialog--show")) {
          $guideDialog.addClass("eg-dialog--show");
        }
      });
      $guideDialog.find(".eg-dialog__close").on("click", () => {
        $guideDialog.removeClass("eg-dialog--show");
      });
    });
  }
}
